import React, {Component} from "react"
import {Col} from "@irati/ui/src/Layout"

import {FormattedMessage} from "@irati/utils/lang"

import {Slider, OccasionIcon, PickerWrapper} from "./styled"

import icons from "./icons"

interface Props {
  selectedIcon?: string
  selectIcon: (icon: string) => void
}

class IconPicker extends Component<Props> {
  componentDidMount() {
    if (!this.props.selectedIcon) {
      this.props.selectIcon(icons[0])
    }
  }

  render() {
    const {selectedIcon, selectIcon} = this.props
    return (
      <PickerWrapper>
        <Col xs={12}>
          <label>
            <FormattedMessage id="admin.occasions.create.fields.icon.label" />
          </label>
          <Slider>
            {icons.map((icon, i) => (
              <OccasionIcon
                key={i}
                src={icon}
                alt="icon"
                className={icon === selectedIcon ? "selected" : ""}
                onClick={() => selectIcon(icon)}
              />
            ))}
          </Slider>
        </Col>
      </PickerWrapper>
    )
  }
}

export default IconPicker
